export default "__VITE_ASSET__BWHXccda__"